import { HostPlatform } from '../../config/hostPlatform';

function byActive(user) {
  return user.active;
}

function byAtlassianUser(user) {
  return user.accountType === 'atlassian';
}

function mapUser(user) {
  return {
    id: user.accountId,
    name: user.name ?? user.displayName,
    photo_tiny: user.avatarUrls && user.avatarUrls['32x32'],
    photo_thumb: user.avatarUrls && user.avatarUrls['48x48'],
    ...user,
  };
}

export const getMyself = async () => {
  const response = await AP.request('/rest/api/3/myself');
  const myself = JSON.parse(response.body);
  return mapUser(myself);
};

export const getUsers = async (query) => {
  const projectId = HostPlatform.getContext().boardId;

  const userResponse = await AP.request(
    query
      ? `/rest/api/3/user/assignable/search?project=${projectId}&recommend=true&accountType=atlassian&query=${query}`
      : `/rest/api/3/user/assignable/search?project=${projectId}&recommend=true&accountType=atlassian`
  );

  const users = JSON.parse(userResponse.body);

  const activeUsers = users
    .filter((user) => user.active)
    .filter((user) => byAtlassianUser(user))
    .map((user) => mapUser(user));

  return activeUsers;
};

async function findUserById(accountId) {
  const response = await AP.request(
    `/rest/api/3/user/search?accountId=${accountId}`
  );
  return JSON.parse(response.body);
}
export const getUsersById = async (userIds) => {
  const allPromises = (userIds || []).map((userId) => findUserById(userId));

  const allUsers = await Promise.all(allPromises);

  return allUsers
    .flat()
    .filter((user) => byActive(user))
    .map((user) => mapUser(user));
};
